export default {
  "h1-title": "เครื่องมือการซื้อขาย",
  imgUrlLang: "-en",
  "public-btn-text": "ประสบการณ์ทันที",
  screen0: {
    title: "สร้างคลังเครื่องมือเพื่อตอบสนองความต้องการในการเทรดของคุณ",
  },
  screen1: {
    title: "เครื่องมือซ้อนทับสินค้าที่มีรูปภาพเดียวกัน",
    desc: "เครื่องมือนี้ช่วยให้นักลงทุนเข้าใจความแข็งแกร่งของ K-line ในช่วงเวลาใดๆ ของสินค้าโภคภัณฑ์ 2 ชนิดได้อย่างชัดเจน และยังสามารถระบุประสิทธิภาพของการทะลุทะลวง",
  },
  screen2: {
    title: "ตัวบ่งชี้ระดับมืออาชีพของ MACD (เส้นคู่)",
    desc: "นี่เป็นเครื่องมือบ่งชี้ MACD ที่ใช้กันทั่วไปสำหรับหุ้นและฟิวเจอร์ส เมื่อเทียบกับ MACD ที่มาพร้อมกับ MT4 จะสอดคล้องกับพฤติกรรมของผู้ใช้ชาวจีนมากกว่า",
  },
  screen3: {
    title: "ตัวบ่งชี้ทางสถิติกำไรและขาดทุนของ MTDriver",
    desc: "เครื่องมือนี้สามารถช่วยให้นักลงทุนระบุกำไรและขาดทุนสำหรับช่วงเวลาต่างๆ",
  },
  screen4: {
    title: "การแจ้งเตือนการเปลี่ยนแปลงราคามือถือ",
    desc: "นักลงทุนส่วนใหญ่มีเวลาจำกัดในการเฝ้าดูตลาด และการแจ้งเตือนการเปลี่ยนแปลงราคาทางโทรศัพท์มือถือสามารถช่วยให้พวกเขาเข้าใจแนวโน้มของตลาดในขณะที่หลีกเลี่ยงเสียงรบกวนจากตลาด",
  },
  screen5: {
    title: "คลิกเดียวปิด EA",
    desc: "อินเทอร์เฟซการดำเนินการอยู่ในอินเทอร์เฟซแผนภูมิ ซึ่งสะดวกสำหรับนักลงทุนในการหยุดการขาดทุนได้รวดเร็วและสะดวกยิ่งขึ้นเมื่อเกิดสภาวะตลาดที่รุนแรง",
  },
  screen6: {
    title: "ลำดับเวลา EA",
    desc: "วางไว้ในโฟลเดอร์ MQL4Experts เป็น EA ที่ออกคำสั่งตามเวลาที่กำหนด การใช้งานง่ายมาก ผู้ใช้ลองสำรวจด้วยตัวเอง",
  },
  screen7: {
    title: "การตรวจสอบตราสารทุน EA",
    desc: "วางไว้ในโฟลเดอร์ MQL4Experts ตรวจสอบ EA ของการเปลี่ยนแปลงมูลค่าสุทธิ ใส่ไฟล์เสียงที่คุณต้องการให้แสดงภายใต้ Sounds จากนั้นกรอกชื่อไฟล์เพลงที่เกี่ยวข้องในชื่อเพลงของ EA",
  },
  EA交易与指标: "EA Forex & Indicator",
  EBC独家精选的MT4:
    "EBC คัดสรร Indicator บน MT4 และ MT5 พร้อมมอบโปรแกรม EA ที่เป็นเอกสิทธิ์เฉพาะ ช่วยเพิ่มความแม่นยำ และประสิทธิภาพการเทรด ปรับกลยุทธ์ตามจังหวะ และเพิ่มโอกาสทำกำไร",
  EBCTurbo账户分析系统:
    "EBC Turbo: ปรับกลยุทธ์การเทรดด้วย Indicator บน MetaTrader ",
  实用型技术指标集:
    "Indicator ที่ใช้งานได้จริง: วิเคราะห์แนวโน้มตลาด และเพิ่มโอกาสทำกำไร",
  外汇EA策略执行器:
    "กลยุทธ์ EA Forex: ตอบสนองต่อความเปลี่ยนแปลงของตลาดอย่างมีประสิทธิภาพ เพื่อให้มั่นใจว่าการตัดสินใจของคุณล้ำหน้าอยู่เสมอ",
  EBCTurbo账户分析系统2: "ระบบวิเคราะห์บัญชี EBC Turbo",
  EBC独家盈亏统计和历史回溯工具:
    "เครื่องมือวิเคราะห์กำไรขาดทุนและประวัติการเทรดย้อนหลังสุดพิเศษของ EBC ผสานระบบประเมินหลายมิติ เพื่อช่วยวิเคราะห์รายละเอียดการเทรดอย่างรอบด้านและช่วยปรับปรุงกลยุทธ์ EA ให้มีประสิทธิภาพสูงสุด",
  净值收益曲线: "กราฟแสดงผลตอบแทน",
  收益率: "อัตราผลกำไร",
  最大回撤: "อัตราขาดทุนสูงสุด",
  标准差: "อัตราส่วนเบี่ยงเบนมาตรฐาน",
  获利系数: "อัตราตัวคูณกำไร",
  夏普比率: "อัตราผลตอบแทนต่อความเสี่ยง",
  盈利交易: "อัตราชนะการเทรด",
  六维评级图: "แผนภูมิหกมิติ",
  每日: "สถิติรายวัน/รายเดือน",
  获取EBCTurbo: "ปลดล็อกบัญชี EBC Turbo",
  实用型技术指标集2: "ชุด Indicator ที่ใช้งานได้จริง",
  经过优化的常用技术指标:
    "Indicator ที่ผ่านการวิจัยและพัฒนา สามารถวิเคราะห์ตลาดจากหลายมุมมอง พร้อมโหมดตั้งค่าที่ปรับแต่งได้ ช่วยให้นักเทรดคาดการณ์แนวโน้มตลาดได้อย่างแม่นยำ",
  同图商品叠加工具: "Overlay Chart Indicator",
  帮助投资者通过叠加两个商品的走势:
    "วิเคราะห์แนวโน้มระหว่างผลิตภัณฑ์สองชนิด โดยการระบุแนวรับหรือจุดทะลุแนวต้าน ช่วยเพิ่มความแม่นยำในการเทรด",
  MACD专业指标: "MACD Pro Indicator (Dual Line)",
  提供比普通MACD更为精准的双线指标:
    "มอบ Indicator Dual Line ที่แม่นยำกว่า MACD ทั่วไป ช่วยให้สามารถระบุสัญญาณเทรดในตลาดได้ดีกว่า พร้อมเพิ่มโอกาสทำกำไร",
  MTDriver盈亏统计指标: "MTDriver Indicator",
  该指标可协助投资者实时统计不同周期内的盈亏情况:
    "คำนวณกำไรขาดทุนแบบเรียลไทม์ โดยให้ข้อมูลและกลยุทธ์ที่เป็นประโยชน์ เพื่อเพิ่มประสิทธิภาพการเทรด",
  价格变动手机推送通知: "การแจ้งเตือนราคาผ่านโทรศัพท์",
  实时监控市场价格波动:
    "แสดงราคาตลาดแบบเรียลไทม์ เมื่อเกิดการเปลี่ยนแปลงสำคัญ ระบบจะส่งการแจ้งเตือนไปยังโทรศัพท์ ช่วยให้นักเทรดสามารถเตรียมตัวรับมือกับตลาดได้ทันท่วงที",
  获取指标: "รับ Indicator",
  外汇EA策略执行器2: "กลยุทธ์ EA Forex",
  基于高级算法自动执行EA交易策略:
    "อิงตามอัลกอริธึมขั้นสูง ระบบจะดำเนินกลยุทธ์การเทรด EA แบบอัตโนมัติ โดยเฝ้าติดตามตลาดแบบเรียลไทม์ พร้อมปรับเปลี่ยนกลยุทธ์แบบไดนามิก เพื่อเพิ่มประสิทธิภาพและความปลอดภัยต่อการเทรด",
  定时下单EA软件: "ส่งออเดอร์ด้วยโปรแกรม EA ",
  通过MT4EA:
    "ดำเนินคำสั่งซื้อขายโดยอัตโนมัติผ่านโปรแกรม EA บน MT4/MT5 ตามเวลาที่กำหนดไว้ล่วงหน้า โดยไม่มีการแทรกแซง เหมาะสำหรับกลยุทธ์ที่ต้องการเทรดในช่วงเวลาที่เฉพาะเจาะจง เพื่อให้มั่นใจว่าการเทรดจะเกิดขึ้นอย่างทันท่วงที",
  EA交易常见问题: "คำถามเกี่ยวกับ EA Forex",
  qaList: [
    {
      q: "1. EA Forex คืออะไร และทำงานอย่างไร?",
      a: [
        "EA ย่อมาจาก Expert Advisor หมายถึงการใช้ระบบการเทรดอัตโนมัติบนแพลตฟอร์ม MT4/MT5 ระบบสามารถซื้อขาย ตั้งจุดตัดขาดทุน (Stop Loss) และจุดทำกำไร (Take Profit) ได้ตามกลยุทธ์ที่กำหนดไว้ล่วงหน้า โดยไม่ต้องส่งคำสั่งซื้อขายโดยมนุษย์ ซึ่งช่วยเพิ่มประสิทธิภาพการเทรด ประหยัดเวลาในการเฝ้าหน้าจอ และลดการใช้อารมณ์ในการเทรด",
      ],
    },
    {
      q: "2. ความแตกต่างระหว่างโปรแกรม EA บนแพลตฟอร์มเทรด คืออะไร?",
      a: [
        "โปรแกรม EA บน MT4 สามารถใช้งานได้เฉพาะบนแพลตฟอร์ม MetaTrader 4 และเขียนด้วยภาษา MQL4; โปรแกรม EA บน MT5 ใช้บนแพลตฟอร์ม MetaTrader 5 โดยเขียนด้วยภาษา MQL5 ซึ่ง MT5 จะรองรับฟังก์ชันการทำงานที่มากกว่าและสามารถทดสอบการเทรดย้อนหลัง (multi-threaded backtesting) ได้ การเลือกใช้งานแพลตฟอร์มใดขึ้นอยู่กับความต้องการในการเทรดและความเข้ากันได้ของโปรแกรม EA โดยทั้งสองแพลตฟอร์มไม่สามารถใช้งานร่วมกันได้",
      ],
    },
    {
      q: "3. ฉันสามารถรันโปรแกรม EA หลายตัวบนแพลตฟอร์มเดียวกันได้หรือไม่?",
      a: [
        "ได้ สามารถรันโปรแกรม EA หลายตัวบน MetaTrader เดียวกันได้ ซึ่งแต่ละ EA ต้องโหลดลงในกราฟที่แยกต่างกัน และในแต่ละกราฟสามารถรัน EA ได้เพียงหนึ่งตัวเท่านั้น ควรระวังไม่ให้ EA แต่ละตัวเกิดความขัดแย้งในการเปิดออร์เดอร์ หรือควรเลี่ยงการโหลดของระบบที่มากเกินไป หากรัน EA หลายตัว",
      ],
    },
    {
      q: "4. EA Forex สามารถเทรดหลายคู่เงินพร้อมกันได้หรือไม่?",
      a: [
        "ได้ แต่ขึ้นอยู่กับการออกแบบของโปรแกรม EA บางตัวมุ่งเน้นการเทรดในคู่เงินเดียว ในขณะที่บางตัวมีความสามารถสูง สามารถรองรับการเทรดหลายสินทรัพย์ได้ โดยเฉพาะโปรแกรม EA ที่สร้างขึ้นบน MT5 เนื่องจากแพลตฟอร์มนี้ มีการรองรับระบบมัลติเทรด (multi-threading) ซึ่งทำให้มีความสามารถในการจัดการการเทรดหลายสินทรัพย์ได้ดียิ่งขึ้น"
      ],
    },
    {
      q: "5. ฉันควรเลือก EA Forex แบบไหนให้เหมาะกับตัวเอง?",
      a: [
        "การเลือกใช้ EA เทรด Forex ควรพิจารณาสไตล์การเทรดของคุณ (เช่น การเทรดตามเทรนด์หรือการสแคลปปิ้ง) ความสามารถในการรับความเสี่ยง การทดสอบการเทรดย้อนหลัง (backtesting) ผลการเทรดจริง นอกจากนั้นควรทดสอบระบบ EA นั้นเหมาะสมกับแพลตฟอร์ม MT4 หรือ MT5？ และควรทดสอบในบัญชีเดโมก่อน เพื่อดูเสถียรภาพและความสามารถในการทำกำไร",
      ],
    },
    {
      q: "6. การเทรดด้วย EA สามารถรับประกันกำไรได้หรือไม่?",
      a: [
        "ไม่มีเครื่องมือเทรดใดที่สามารถรับประกันผลกำไรได้ ประสิทธิภาพของ EA ขึ้นอยู่กับกลยุทธ์ สภาพตลาด และการจัดการความเสี่ยง ทั้ง MT4 และ MT5 เป็นเครื่องมือที่ช่วยสนับสนุนการเทรด แต่นักเทรดยังคงต้องคอยติดตามผลการเทรดและปรับปรุงระบบการเทรด EA อยู่เสมอ"
      ],
    },
  ],
  url: "https://ebcturbo.com/tools?language=en",
};
